import { createContext } from "react";
import type { NavigateOptions, To } from "react-router-dom";

import type { IClientConfig } from "../config";
import { Player } from "../db";

declare module "react-router" {
  interface NavigateFunction {
    (to: To, options?: NavigateOptions): void;
    (delta: number): void;
  }
}

export interface IContext extends IClientConfig {
  /** WebSocket is connected. */
  connected: boolean;

  /** The website is in match. */
  inMatch: boolean;

  /** Open queue settings pop-up. */
  queueSettings: boolean;

  /** Updates the context. */
  updateContext: (update: Partial<Omit<IContext, "updateContext">>) => void;
}

export const defaultContext: IContext = {
  clientId:      "",
  connected:     false,
  inMatch:       false,
  player:        new Player(),
  queueSettings: false,
  stage:         "unknown",
  updateContext: () => {}
};

/** General purpose context. */
export const Context = createContext(defaultContext);
